module.exports = __webpack_public_path__ + "site/img/serviceen.b1f57772.png";